import AutoAwesome from '@mui/icons-material/AutoAwesome'
import { keyframes, Stack, Typography } from '@mui/material'
import { ProjectModelVersion } from '@/types/project-models'
import { getStatusLabel } from '@/utils/model-page'

const pulseAnimation = keyframes`
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
`

const statusColorMap: Record<
  ProjectModelVersion['training_status'],
  'neutral' | 'primary' | 'success' | 'error'
> = {
  starting: 'neutral',
  starting_gpu: 'neutral',
  training: 'primary',
  trained: 'primary',
  evaluating: 'primary',
  terminating_gpu: 'neutral',
  canceling: 'neutral',
  canceled: 'neutral',
  completed: 'success',
  error: 'error',
}

type ModelStatusProps = {
  status: ProjectModelVersion['training_status']
}

export default function ModelStatusLabel({ status }: ModelStatusProps) {
  const colorKey = statusColorMap[status] || 'neutral'
  const statusLabel = getStatusLabel(status)

  if (!status) {
    return <Typography color="text.secondary">{statusLabel}</Typography>
  }

  if (statusLabel === 'Training') {
    return (
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <AutoAwesome
          sx={{
            fontSize: '1rem',
            animation: `${pulseAnimation} 2s infinite ease-in-out`,
          }}
          color={colorKey}
        />
        <Typography color={`${colorKey}.main`}>{statusLabel}</Typography>
      </Stack>
    )
  }

  return <Typography color={`${colorKey}.main`}>{statusLabel}</Typography>
}
